import thunk from "redux-thunk";
import rootReducer from '../modules/index';
import { createStore, applyMiddleware, compose } from "redux";

import { authorize } from "../modules/auth";
import { jwt } from "./middleware";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(rootReducer, composeEnhancers(
    applyMiddleware(jwt, thunk)
));

store.dispatch(authorize());

export default store;
